export default {

    date_of_birth: "",
    email: "",
    mobile: "",
    username: "",
    name: "",
    sex: "",
    thumb: "",
    thumb_url: "",
    age: 0,
    nickname: "",
    userid: "",
    inspector: {
        id: 0,
        idcard_no: "",
        region: {
            name: "",
            language: "",
            region: "",
            region_code: "",
            country: "",
            country_code: "",
            province: "",
            province_code: "",
            city: "",
            address: "",
            town: "",
            district: "",
            full_address: "",
            latitude: 0,
            longitude: 0
        },
        appraisal_certificates: [],
        self_introduction: "",
        level: "",
        identifier: "",
        create_at: ""
    }
}